import { Link } from 'react-router-dom';
import { Footer } from '../components/footer/footer';
import { Scroll } from '../components/scroll/scroll';
import { Header } from '../components/header/header';
import { useI18n } from '../i18n';
import { ContentIndex } from '../components/content-index';
import { articlesIndex } from '../data/articles-data';
import './articles.scss';

export default function Articles() {
  const { translations, language } = useI18n();
  const currentLanguageArticles = articlesIndex
    .filter((article) => article.language === language)
    .slice()
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

  const featured = currentLanguageArticles.find((article) => article.featured);
  const articleList = featured
    ? currentLanguageArticles.filter((article) => article.id !== featured.id)
    : currentLanguageArticles;

  return (
    <Scroll>
      <main className="page">
        <Header
          title={translations.nav.articles}
          description={translations.articlesPage.description}
          breadcrumbs={[
            { label: 'GAraujo', href: '/' },
            { label: translations.nav.articles, href: '/articles' },
          ]}
        />
        <ContentIndex />

        <section>
          {featured && (
            <article className="featured-article">
              <h2>{featured.title}</h2>
              <p>{featured.desc}</p>
              <Link to={`/articles/${featured.id}`} className="button button--lg">
                {translations.articlesPage.featuredLabel}
              </Link>
            </article>
          )}

          
          <div className="articles-list">
            {articleList.map((article) => (
              <Link key={article.id} to={`/articles/${article.id}`} className="article-card">
                <div className="article-card__preview">
                  <img src={article.image} alt={article.title} />
                </div>
                <div className="article-card__content">
                  <div className="article-card__info">
                    <h3 className="article-card__title">{article.title}</h3>
                    <p className="article-card__desc">{article.desc}</p>
                  </div>
                  <div className="article-card__meta">
                    <span>{new Date(article.createdAt).toLocaleDateString()}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <hr />
          <div className="articles-note">
            <p>
              {translations.articlesPage.notePrefix}{' '}
              <a href="https://aifront.substack.com/" target="_blank" rel="noreferrer noopener">
                {translations.articlesPage.noteSubstack}
              </a>{' '}
              {translations.articlesPage.noteAnd}{' '}
              <a href="https://medium.com/@fromspace" target="_blank" rel="noreferrer noopener">
                {translations.articlesPage.noteMedium}
              </a>.
            </p>
          </div>
        </section>

        <Footer />
      </main>
    </Scroll>
  );
}
